import { Spinner } from 'react-bootstrap';

interface LoadingOverlayProps {
  loading: boolean;
}

export const LoadingOverlay = ({ loading }: LoadingOverlayProps) => {
  if (!loading) {
    return null;
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1050,
      }}
    >
      <div className="text-center">
        <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
        <div className="mt-3 text-primary">Loading can takes up to 1 minutes...</div>
      </div>
    </div>
  );
};
